// extracted by mini-css-extract-plugin
export default {"pageWrapper":"About_pageWrapper__doL+E","wrapper":"About_wrapper__dP8ai"};